import { useEffect, useMemo, useRef, useState } from 'react';
import useGroupSettingsStore from '@modules/digital-signage/components/group-settings/store/group-settings.store.ts';
import { PlaylistScreenOption } from '@modules/digital-signage/model/playlists.model.ts';
import { AssignedEntityEnum } from '@modules/digital-signage/model/group-settings.model.ts';
import { getPreviewScreen } from '@modules/digital-signage/components/group-settings/utils/group-settings.utils.ts';

export const usePreviewScreen = (
  screen: PlaylistScreenOption | null,
  playlist: PlaylistScreenOption | null
) => {
  const { screensList, playlistsList } = useGroupSettingsStore();
  const [lastSelected, setLastSelected] = useState<AssignedEntityEnum | null>(
    null
  );
  const previousIds = useRef<{ screen?: string; playlist?: string }>({
    screen: screen?.id,
    playlist: playlist?.id
  });

  useEffect(() => {
    const screenId = screen?.id;
    if (screenId && screenId !== previousIds.current.screen) {
      setLastSelected(AssignedEntityEnum.Screen);
    }
    previousIds.current.screen = screenId;
  }, [screen]);

  useEffect(() => {
    const playlistId = playlist?.id;
    if (playlistId && playlistId !== previousIds.current.playlist) {
      setLastSelected(AssignedEntityEnum.Playlist);
    }
    previousIds.current.playlist = playlistId;
  }, [playlist]);

  return useMemo(
    () =>
      getPreviewScreen({
        screensList,
        playlistsList,
        screen,
        playlist,
        lastSelected
      }),
    [lastSelected, screen, playlist, screensList, playlistsList]
  );
};
